import { Link, useParams } from "react-router-dom";
import Spesifikasi from "../Components/Spesifikasi";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, A11y } from "swiper/modules";

import "swiper/css";
import "swiper/css/navigation";
import { useEffect, useState } from "react";
import Loading from "../Components/Loading";
import { NavbarWithLogo } from "../Components/Navbar";

export default function Detail() {
  const { id } = useParams();
  const [detail, setDetail] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const getDetail = async () => {
      const response = await fetch(
        `https://kjpp-server.vercel.app/api/properties/${id}`
      );

      const json = await response.json();

      if (response.ok) {
        setDetail(json);
      } else {
        setError(json.mssg);
      }
      setLoading(false);
    };

    getDetail();
  }, [id]);

  return (
    <>
      <NavbarWithLogo />
      <div className="px-5 xl:px-10 pt-20 py-5 min-h-screen bg-[#F2F4F5]">
        <div className="h-full p-5 bg-white border rounded-xl">
          {error && (
            <div>
              <h1 className="mb-5 text-4xl text-red-600">{error}</h1>
              <Link to={"/"} className="text-blue-600 underline">
                Back
              </Link>
            </div>
          )}

          {loading && (
            <div className="flex items-center justify-center w-full h-screen">
              <Loading />
            </div>
          )}
          {!loading && detail && (
            <div className="block lg:flex lg:gap-10 lg:justify-center">
              <div className="w-full max-w-screen-sm max-h-screen mx-auto mb-5 lg:w-1/2 xxl:w-1/3">
                <Swiper
                  className="mb-5 h-2/3"
                  modules={[Navigation, A11y]}
                  slidesPerView={1}
                  navigation
                >
                  {detail.foto.map((foto, i) => (
                    <SwiperSlide key={i}>
                      <div className="object-fill w-full h-full rounded-sm">
                        <img
                          src={foto.secure_url}
                          className="object-cover w-full h-full"
                          alt={foto.secure_url}
                        />
                      </div>
                    </SwiperSlide>
                  ))}
                </Swiper>
              </div>

              <div className="w-full max-w-screen-lg lg:w-1/2">
                <div className="pb-5 border-b">
                  <h1 className="mt-5 text-2xl font-bold">
                    {detail.harga.toLocaleString("id-ID", {
                      style: "currency",
                      currency: "IDR",
                    })}
                  </h1>
                  <p className="mt-3 mb-2 font-semibold capitalize">
                    {detail.wilayah}, {detail.alamat}
                  </p>
                  <Link
                    className="underline"
                    to={`https://www.google.com/maps/?q=${detail.koordinat}`}
                    target="_blank"
                  >
                    Maps
                  </Link>
                </div>
                <div className="py-5">
                  <h2 className="mb-5 text-lg font-semibold">Spesifikasi</h2>
                  <Spesifikasi data={detail} />
                </div>

                <div className="py-5 mb-5 border-b">
                  <h2 className="mb-5 text-lg font-semibold">Deskripsi</h2>
                  <p className="text-justify capitalize">{detail.deskripsi}</p>
                </div>
                <button className="w-full px-4 py-2 mb-2 text-center transition duration-200 border rounded-md border-primary hover:bg-primary hover:text-white">
                  <Link
                    to={`https://wa.me/62${detail.noHPAdmin}`}
                    className="w-full"
                    target="_blank"
                  >
                    Chat Admin
                  </Link>
                </button>
                <button className="w-full py-3 font-bold text-center text-white rounded-md bg-primary">
                  <Link
                    to={`https://wa.me/62${detail.noHPPemilik}`}
                    className="w-full"
                    target="_blank"
                  >
                    Chat Pemilik
                  </Link>
                </button>
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
}
